import laundriesService from "api/laundriesService";
import { useMutation, useQueryClient } from "react-query";

import { IEditLaundryHolidayBody } from "types/laundry";

const useUpdateLaundryHolidayMutation = () => {
  const queryClient = useQueryClient()
  return useMutation(async (data: IEditLaundryHolidayBody) => {
    try {
      const res = await laundriesService.updateLaundryHoliday(data)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }, {
    onMutate: async newHoliday => {
      console.log("newHoliday", newHoliday)
      // await queryClient.cancelQueries(['laundry_holidays', newHoliday.id])
      
      // const previousHolidays = queryClient.getQueryData(['laundry_holidays'])

      // queryClient.setQueryData(['laundry_holidays', newHoliday.id], newHoliday)

      // return { previousHolidays, newHoliday }
    }
  }) 
}

export default useUpdateLaundryHolidayMutation